import type { QueuedPhoto } from "./photo-queue-db";

export const PHOTO_RECOVERY_PATH = "/photo-recovery";

export interface RecoveredPhotoConfirmation {
  success: true;
  photoId: string;
  recordId: string;
  scope: string;
  caption: string;
  repetition: number;
  uploadDigest: string;
  storedDigest: string;
  verifiedAt: string;
}

export const isRecoveryArchive = (photo: QueuedPhoto) =>
  photo.status === "uploaded" && Boolean(photo.recoveryCompletion);

/** One allowlisted destination, not an arbitrary post-login redirect. */
export function photoSignInDestination(search: string) {
  return new URLSearchParams(search).get("recovery") === "1"
    ? PHOTO_RECOVERY_PATH
    : "/";
}

export function photoDownloadName(photo: QueuedPhoto, original: boolean) {
  const mime = original ? photo.originalMimeType : photo.mimeType;
  const extensions: Record<string, string> = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/webp": "webp",
    "image/heic": "heic",
    "image/heif": "heif",
  };
  return `${photo.id}-${original ? "original" : "edited"}.${extensions[mime ?? ""] ?? "bin"}`;
}

export function photoRecoveryDetails(photo: QueuedPhoto) {
  return {
    photoId: photo.id,
    workOrderRecordId: photo.workOrderRecordId,
    caption: photo.caption,
    status: photo.status,
    attempts: photo.attempts,
    recoveryHold: photo.recoveryHold === true,
    originalAvailable: Boolean(photo.originalData?.byteLength),
    originalBytes: photo.originalData?.byteLength ?? null,
    originalMimeType: photo.originalMimeType ?? null,
    editedBytes: photo.data.byteLength,
    editedMimeType: photo.mimeType,
    error: photo.error ?? null,
    recoveryCompletion: photo.recoveryCompletion ?? null,
  };
}
